export default __webpack_public_path__ + "static/media/step2_bingo.8b658e48.png";